import React from 'react'
import { StaticQuery, graphql } from 'gatsby'
import Img from 'gatsby-image'

import style from './SDKS.module.scss'

const SDKS = ({
  children
}) => {
  const [text, text2, ...other] = children
  console.dir(children)
  return (
    <StaticQuery query={query} render={data => (
      <div className={style.sdks}>
        {text}{text2}
        <div className={style.image}>
          <Img fluid={{...data.file.childImageSharp.fluid, objectFit: 'cover' }} />
        </div>
        <div className={style.buttons}>
          { other }
        </div>
      </div>
    )} />
  )
}

const query = graphql`
query {
  file(relativePath: { eq: "sdks.png" }, sourceInstanceName: { eq: "pages" }) {
    childImageSharp {
      fluid {
        ...GatsbyImageSharpFluid_withWebp_tracedSVG
      }
    }
  }
}
`

export default SDKS
export { default as SDK } from './SDK'
